import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Col, Form, Row } from "react-bootstrap";
import { isDemoUser } from '../../utils/demo';
import { MetricsDateSelector } from '../filters/MetricsDateSelector';
import { METRICS_FORECAST_HORIZON_OPTIONS, METRICS_PERIOD_OPTIONS } from '../filters/metricsFilterOptions';

/**
 * BoardingReportFilterBar options
 */
export const BoardingReportFilterBar = (props: {
    filterOptions: any,
    updateFilterOptions: any,
    filterDateOptions: any,
    setFilterDateOptions: any,
    refresh: any,
    isLoadingMetrics: boolean,
    user: any,
}) => {

    const handleCheckFilter = (checked: boolean, value: string, key: string = "dimension_filter_values") => {
        const filterVals = new Set([...props.filterOptions[key]]);
        if (checked) {
            filterVals.add(value);
        } else {
            filterVals.delete(value);
        }

        props.updateFilterOptions(key, Array.from(filterVals));
    }

    return (
        <>
            <Row className="metrics-sidebar-update" style={{marginTop: isDemoUser(props.user) ? "80px" : undefined}}>
                <Col md={12} className="d-grid gap-2">
                    <Button
                        variant="secondary"
                        size="sm"
                        onClick={() => {props.refresh()}}
                        disabled={props.isLoadingMetrics}
                    >
                        {props.isLoadingMetrics ? <><FontAwesomeIcon icon={faSpinner} spin /> Loading...</> : "Update"}
                    </Button>
                </Col>
            </Row>
            <Row className="mb-4" style={{marginTop: '48px'}}>
                <Col md={12}>
                    <div className="metrics-control-title">Date Range</div>
                    <MetricsDateSelector
                        filterDateOptions={props.filterDateOptions}
                        setFilterDateOptions={props.setFilterDateOptions}
                    />
                </Col>
            </Row>
            <Row className="mt-2 mb-4">
                <Col md={12}>
                    <div className="metrics-control-title">Period</div>

                    <Form.Select className="d-flex" onChange={(e) => props.updateFilterOptions("period", e.target.value)}>
                        {
                            METRICS_PERIOD_OPTIONS.map((selectOption: any, index: number) => {
                                return (
                                    <option key={selectOption.id} selected={props.filterOptions["period"] === index} value={index}>
                                        {selectOption.name}
                                    </option>
                                )
                            })
                        }
                    </Form.Select>
                </Col>
            </Row>
            <Row className="mt-2 mb-4">
                <Col md={12}>
                    <div className="metrics-control-title">Forecast Horizon</div>

                    <Form.Select className="d-flex" onChange={(e) => props.updateFilterOptions("forecast_horizon", e.target.value)}>
                        {
                            METRICS_FORECAST_HORIZON_OPTIONS.map((selectOption: any, index: number) => {
                                return (
                                    <option key={selectOption.id} selected={props.filterOptions["forecast_horizon"] === index} value={index}>
                                        {selectOption.name}
                                    </option>
                                )
                            })
                        }
                    </Form.Select>
                </Col>
            </Row>
            <Row className="mt-2 mb-4">
                <Col md={12}>
                    <div className="metrics-control-title">Display Options</div>

                    <div className="d-flex">
                        <Form.Check
                            type={"checkbox"}
                            checked={true}
                            onChange={(e) => handleCheckFilter(e.target.checked, "SHOW_FORECAST", "display_options")}
                        >
                            <Form.Check.Input id={"showForecast"} type="checkbox" checked={props.filterOptions["display_options"].includes("SHOW_FORECAST")} onChange={(e) => handleCheckFilter(e.target.checked, "SHOW_FORECAST", "display_options")} />
                            <Form.Check.Label htmlFor={"showForecast"}>Show Forecast</Form.Check.Label>
                        </Form.Check>
                    </div>
                    <div className="d-flex">
                        <Form.Check
                            type={"checkbox"}
                            checked={true}
                            onChange={(e) => handleCheckFilter(e.target.checked, "SHOW_FORECAST_BOUNDS", "display_options")}
                        >
                            <Form.Check.Input id={"showForecastBounds"} type="checkbox" checked={props.filterOptions["display_options"].includes("SHOW_FORECAST_BOUNDS")} onChange={(e) => handleCheckFilter(e.target.checked, "SHOW_FORECAST_BOUNDS", "display_options")} />
                            <Form.Check.Label htmlFor={"showForecastBounds"}>Show Forecast Bounds</Form.Check.Label>
                        </Form.Check>
                    </div>
                    <div className="d-flex">
                        <Form.Check
                            type={"checkbox"}
                            checked={true}
                            onChange={(e) => handleCheckFilter(e.target.checked, "SHOW_LAST_WEEK", "display_options")}
                        >
                            <Form.Check.Input id={"showLastWeek"} type="checkbox" checked={props.filterOptions["display_options"].includes("SHOW_LAST_WEEK")} onChange={(e) => handleCheckFilter(e.target.checked, "SHOW_LAST_WEEK", "display_options")} />
                            <Form.Check.Label htmlFor={"showLastWeek"}>Show Last Week</Form.Check.Label>
                        </Form.Check>
                    </div>
                    <div className="d-flex">
                        <Form.Check
                            type={"checkbox"}
                            checked={true}
                            onChange={(e) => handleCheckFilter(e.target.checked, "SHOW_PAST_FORECAST", "display_options")}
                        >
                            <Form.Check.Input id={"showPastForecast"} type="checkbox" checked={props.filterOptions["display_options"].includes("SHOW_PAST_FORECAST")} onChange={(e) => handleCheckFilter(e.target.checked, "SHOW_PAST_FORECAST", "display_options")} />
                            <Form.Check.Label htmlFor={"showPastForecast"}>Show Past Forecast</Form.Check.Label>
                        </Form.Check>
                    </div>
                    <div className="d-flex">
                        <Form.Check
                            type={"checkbox"}
                            checked={true}
                            onChange={(e) => handleCheckFilter(e.target.checked, "SHOW_PAST_FORECAST_BOUNDS", "display_options")}
                        >
                            <Form.Check.Input id={"showPastForecastBounds"} type="checkbox" checked={props.filterOptions["display_options"].includes("SHOW_PAST_FORECAST_BOUNDS")} onChange={(e) => handleCheckFilter(e.target.checked, "SHOW_PAST_FORECAST_BOUNDS", "display_options")} />
                            <Form.Check.Label htmlFor={"showPastForecastBounds"}>Show Past Forecast Bounds</Form.Check.Label>
                        </Form.Check>
                    </div>
                </Col>
            </Row>
        </>
    );
};
